import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MarketingChrome } from "../components/MarketingChrome";
import { LoginBurst } from "../components/LoginBurst";
import { IconEye, IconEyeOff } from "../components/Icons";
import { useAuth } from "../store/auth";
import { routeForContributor } from "../lib/routing";

export function Login() {
  const login = useAuth((state) => state.login);
  const loading = useAuth((state) => state.loading);
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    if (!identifier.trim() || !password) {
      setError("Enter your email and password.");
      return;
    }
    try {
      const contributor = await login(identifier.trim(), password);
      navigate(routeForContributor(contributor), { replace: true });
    } catch (err) {
      setError((err as Error).message);
    }
  }

  return (
    <MarketingChrome back={{ to: "/", label: "Back to Inputry", short: "Back" }} footer="compact">
      <div className="auth-page login-page">
        <div className="auth-split">
          <aside className="auth-visual" aria-hidden="true">
            <LoginBurst />
            <div className="flow-pills">
              <span>Record</span>
              <i aria-hidden="true">→</i>
              <span>Submit</span>
              <i aria-hidden="true">→</i>
              <span>Get paid</span>
            </div>
          </aside>

          <form className="panel-card" onSubmit={handleSubmit} noValidate>
            <div className="kicker"><i /> Contributor network</div>
            <h1>Welcome back</h1>
            <p className="sub">Sign in to your Inputry contributor account.</p>

            <div className="field">
              <label htmlFor="identifier">Email address or WhatsApp number</label>
              <input
                id="identifier"
                value={identifier}
                autoComplete="username"
                placeholder="Enter email"
                onChange={(event) => setIdentifier(event.target.value)}
              />
            </div>

            <div className="field">
              <label htmlFor="password">Password</label>
              <div className="password-wrap">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  autoComplete="current-password"
                  placeholder="Enter your password"
                  onChange={(event) => setPassword(event.target.value)}
                />
                <button
                  type="button"
                  className="eye-btn"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  onClick={() => setShowPassword((value) => !value)}
                >
                  {showPassword ? <IconEyeOff width={18} height={18} /> : <IconEye width={18} height={18} />}
                </button>
              </div>
            </div>

            <div className="form-links">
              <button type="button" className="show-pass" onClick={() => setShowPassword((value) => !value)}>
                {showPassword ? "Hide password" : "Show password"}
              </button>
              <Link to="/forgot-password">Forgot password?</Link>
            </div>

            {error && <div className="form-error">{error}</div>}

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>

            <p className="fine">
              New to Inputry? <Link to="/apply">Apply to contribute</Link>
              <br />
              Have an invitation? <Link to="/signup">Create your account</Link>
            </p>
          </form>
        </div>
      </div>
    </MarketingChrome>
  );
}
